import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import ResumeBuilder from './pages/ResumeBuilder';
import Templates from './pages/Templates';
import Examples from './pages/Examples';
import Login from './pages/Login';
import Register from './pages/Register';
import CompanyDashboard from './pages/CompanyDashboard';
import CandidateDashboard from './pages/CandidateDashboard';
import CreateJob from './pages/CreateJob';
import EditJob from './pages/EditJob';
import ProfileEdit from './pages/ProfileEdit';
import EducationManagement from './pages/EducationManagement';
import ExperienceManagement from './pages/ExperienceManagement';
import CertificatesManagement from './pages/CertificatesManagement';
import ResumeUpload from './pages/ResumeUpload';
import JobDetail from './pages/JobDetail';
import JobApplications from './pages/JobApplications';
import AIResumeRecommendation from './pages/AIResumeRecommendation';
import Pricing from './pages/Pricing';
import ResumeAnalyzer from './pages/ResumeAnalyzer';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

// Create a client
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <AuthProvider>
          <Router>
            <div className="App">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/templates" element={<Templates />} />
              <Route path="/examples" element={<Examples />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route 
                path="/ai-recommendations" 
                element={
                  <ProtectedRoute requirePremium>
                    <AIResumeRecommendation />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/resume-analyzer" 
                element={
                  <ProtectedRoute requirePremium>
                    <ResumeAnalyzer />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/resume-builder" 
                element={
                  <ProtectedRoute>
                    <ResumeBuilder />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/company-dashboard" 
                element={
                  <ProtectedRoute>
                    <CompanyDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/candidate-dashboard" 
                element={
                  <ProtectedRoute>
                    <CandidateDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/profile/edit" 
                element={
                  <ProtectedRoute>
                    <ProfileEdit />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/profile/education" 
                element={
                  <ProtectedRoute>
                    <EducationManagement />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/profile/experience" 
                element={
                  <ProtectedRoute>
                    <ExperienceManagement />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/profile/certificates" 
                element={
                  <ProtectedRoute>
                    <CertificatesManagement />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/profile/resume" 
                element={
                  <ProtectedRoute>
                    <ResumeUpload />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/jobs/create" 
                element={
                  <ProtectedRoute>
                    <CreateJob />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/jobs/:id/edit" 
                element={
                  <ProtectedRoute>
                    <EditJob />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/jobs/:id" 
                element={
                  <ProtectedRoute>
                    <JobDetail />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/jobs/:jobId/applications" 
                element={
                  <ProtectedRoute>
                    <JobApplications />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/builder/:templateId?" 
                element={
                  <ProtectedRoute>
                    <ResumeBuilder />
                  </ProtectedRoute>
                } 
              />
              </Routes>
              <Toaster 
                position="top-right"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#363636',
                    color: '#fff',
                  },
                }}
              />
            </div>
          </Router>
        </AuthProvider>
      </LanguageProvider>
    </QueryClientProvider>
  );
}

export default App;
